function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "production",
  transform: "translate(-8 -8)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_309",
  "data-name": "Path 309",
  d: "M37.572,9.939H22.059V9.454a.485.485,0,0,0-.485-.485H20.6V8.485A.485.485,0,0,0,20.12,8H15.272a.485.485,0,0,0-.485.485V8.97h-.97a.485.485,0,0,0-.485.485v.485H8.485A.485.485,0,0,0,8,10.424v1.454a.485.485,0,0,0,.485.485h4.848v.485a.485.485,0,0,0,.485.485h.97v2.424a.559.559,0,0,0,.024.151v0l.97,2.909a.485.485,0,0,0,.46.331V20.6a.485.485,0,0,0,.142.343l.97.97a.486.486,0,0,0,.686,0l.97-.97a.485.485,0,0,0,.142-.343V19.15a.485.485,0,0,0,.46-.331l.97-2.909v0a.57.57,0,0,0,.024-.151V13.333h.97a.485.485,0,0,0,.485-.485v-.485H37.572a.485.485,0,0,0,.485-.485V10.424A.485.485,0,0,0,37.572,9.939ZM13.333,11.393H8.97v-.485h4.363Zm1.454.97H14.3V9.939h.485ZM18.18,20.4l-.485.485-.485-.485V19.15h.97Zm.62-2.223H16.591l-.647-1.939h3.5Zm.834-2.909H15.757V8.97h3.878Zm1.454-2.909H20.6V9.939h.485Zm16-.97H22.059v-.485H37.087Z",
  transform: "translate(0 0)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_310",
  "data-name": "Path 310",
  d: "M144.485,44.363h1.939a.485.485,0,0,0,.485-.485V40.485a.485.485,0,0,0-.485-.485h-1.939a.485.485,0,0,0-.485.485v3.393A.485.485,0,0,0,144.485,44.363Zm.485-3.393h.97v2.424h-.97Z",
  transform: "translate(-127.759 -30.061)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_311",
  "data-name": "Path 311",
  d: "M160.97,248.485a.485.485,0,1,0-.97,0v2.424a.485.485,0,1,0,.97,0Z",
  transform: "translate(-142.789 -225.456)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_312",
  "data-name": "Path 312",
  d: "M353.446,322.483l-4.362-2.425a.483.483,0,0,0-.471,0l-4.362,2.425a.488.488,0,0,0-.25.423v5.333a.485.485,0,0,0,.249.424l4.363,2.424a.482.482,0,0,0,.469,0h0l4.363-2.424a.485.485,0,0,0,.249-.424v-5.333A.476.476,0,0,0,353.446,322.483Zm-5.083,7.355-3.393-1.885V323.73l3.393,1.885Zm.485-5.063-3.365-1.87,3.365-1.869,3.365,1.869Zm3.878,3.178-3.393,1.885v-4.223l3.393-1.885Z",
  transform: "translate(-315.639 -293.091)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_313",
  "data-name": "Path 313",
  d: "M185.446,322.483l-4.362-2.425a.483.483,0,0,0-.471,0l-4.362,2.425a.488.488,0,0,0-.25.423v5.333a.485.485,0,0,0,.249.424l4.363,2.424a.482.482,0,0,0,.469,0h0l4.363-2.424a.485.485,0,0,0,.249-.424v-5.333A.476.476,0,0,0,185.446,322.483Zm-5.083,7.355-3.394-1.885V323.73l3.394,1.885Zm.485-5.063-3.365-1.87,3.365-1.869,3.365,1.869Zm3.878,3.178-3.393,1.885v-4.223l3.393-1.885Z",
  transform: "translate(-157.82 -293.091)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_314",
  "data-name": "Path 314",
  d: "M17.446,322.483l-4.362-2.425a.483.483,0,0,0-.471,0L8.25,322.483a.488.488,0,0,0-.25.423v5.333a.485.485,0,0,0,.249.424l4.363,2.424a.482.482,0,0,0,.469,0h0l4.363-2.424a.485.485,0,0,0,.249-.424v-5.333A.476.476,0,0,0,17.446,322.483Zm-5.083,7.355L8.97,327.954V323.73l3.393,1.885Zm.485-5.063-3.365-1.87,3.365-1.869,3.365,1.869Zm3.878,3.178-3.393,1.885v-4.223l3.393-1.885Z",
  transform: "translate(0 -293.091)",
  fill: "#ac1ede"
}));

var SvgProduction = function SvgProduction(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.057,
    height: 30.057,
    viewBox: "0 0 30.057 30.057",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProduction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/production.cb0ef33d.svg";
export { ForwardRef as ReactComponent };